import React from "react";
import Carousel from "../Carousel/Carousel";
import Intro from "../Intro/Intro";
import Products from "../Products/Products";
import Industries from "../Industries/Industries";
import Company from "../Company/Company";
import Services from "../Services/Services";
import Contact from "../Contact/Contact";
import ChatWidget from "../ChatWidget/ChatWidget";

const MainLayout = () => {
  return (
    <div className="main-layout">
      <div className="content">
        <Carousel />
        <Intro />
        <Products />
        <Services />
        <Industries />
        <Company />
        <Contact />
      </div>
       <ChatWidget />
    </div>
  );
};

export default MainLayout;
